import {
  Box,
  BoxProps,
  Button,
  Divider,
  Heading,
  List,
  Text,
} from "@chakra-ui/react";
import { PricingDetail } from "./pricing-detail";
export interface PricingCardProps extends BoxProps {
  features: string[];
  name: string;
  duration: string;
  extras: string;
  description: string;
  price: React.ReactNode;

  colorScheme: string;
  action: {
    label: string;
    onClick?: () => void;
  };
}

export const PricingCard = (props: PricingCardProps) => {
  const {
    features,
    name,
    description,
    duration,
    price,
    extras,
    action,
    colorScheme: c,
    ...rest
  } = props;

  return (
    <Box p={{ base: "10", md: "16" }} {...rest}>
      <Heading>{name}</Heading>
      <Divider
        opacity={1}
        borderWidth="2px"
        borderColor={`${c}.500`}
        my="6"
        w="56px"
      />

      <Text maxW="280px" fontSize="lg">
        {description}
      </Text>

      <Box mt="2">
        <Text fontSize={{ base: "6xl", md: "7xl" }} fontWeight="extrabold">
          {price}
        </Text>
        <Text casing="uppercase" fontWeight="bold">
          {duration}
        </Text>
        <Text mt="2" color={"gray.600"}>
          {extras}
        </Text>
      </Box>

      <Button
        my="8"
        size="lg"
        fontSize="md"
        colorScheme={c}
        onClick={action.onClick}
      >
        {action.label}
      </Button>

      <Box>
        <Text fontWeight="bold" mb="4">
          What you get:
        </Text>
        <List spacing="4">
          {features.map((feature, index) => (
            <PricingDetail key={index} iconColor={`${c}.500`}>
              {feature}
            </PricingDetail>
          ))}
        </List>
      </Box>
    </Box>
  );
};
